let _ = t => t,
  _t;
import { useCallback, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { CRM_FULL_WIDTH } from '../../crm-sidebar/constants';
import ThreadViewProvider from '../../thread-view/components/ThreadViewProvider';
import InboxContextualSidebar from './InboxContextualSidebar';
import InstallCodePaneWrapperContainer from '../../verify-install/containers/InstallCodePaneWrapperContainer';
import { useLocalStorage } from '../../local-storage/hooks/useLocalStorage';
import { ConversationsTaxonomyPanel } from 'zorse-crm-components-lib';
import { useTaxonomyFlow } from '../../zorse/hooks/useTaxonomyFlow';
import InboxViewMemberDetailsHeader from '../../detail-header/components/InboxViewMemberDetailsHeader';
import { useConversationHandoffErrorAlert } from '../hooks/useConversationHandoffErrorAlert';
import InboxThreadView from './InboxThreadView';
import { TOOLBAR_HEIGHT } from '../../constants/Dimensions';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MIN_SCREENWIDTH = 1260;
const MIN_MAIN_CONTEXT_WIDTH = 400;
const MIN_MAIN_CONTEXT_WIDTH_WITH_SIDEBAR = MIN_MAIN_CONTEXT_WIDTH + CRM_FULL_WIDTH;
const ThreadOverviewFlex = styledWithTheme.div(_t || (_t = _`
{
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: stretch;

  .right-sidebar-enter {
    width: 0%;
    opacity: 0;
  }
  .right-sidebar-enter-active {
    opacity: 1;
    width: ${0}px;
    transition: all 200ms cubic-bezier(0.42, 0, 0.58, 1);
  }
  .right-sidebar-exit {
    width: ${0};
  }
  .right-sidebar-exit-active {
    width: 0%;
    opacity: 0;
    transition: all 200ms cubic-bezier(0.42, 0, 0.58, 1);
  }
}
`), CRM_FULL_WIDTH, CRM_FULL_WIDTH);
const CONTEXTUAL_SIDEBAR_STATE = 'CONTEXTUAL_SIDEBAR_STATE';
const OPEN = 'OPEN';
const CLOSED = 'CLOSED';
const InboxThreadOverview = ({
  focusedThreadId
}) => {
  const initialToggleState = window.innerWidth < MIN_SCREENWIDTH ? CLOSED : OPEN;
  const [item, setItem] = useLocalStorage({
    key: CONTEXTUAL_SIDEBAR_STATE,
    initialValue: initialToggleState
  });
  const isOpen = item === OPEN;
  const toggleSidebar = useCallback(() => setItem(item === OPEN ? CLOSED : OPEN), [item, setItem]);
  const MainContextMinWidth = isOpen ? `${MIN_MAIN_CONTEXT_WIDTH_WITH_SIDEBAR}px` : `${MIN_MAIN_CONTEXT_WIDTH}px`;
  const [isTaxonomyPanelOpen, setIsTaxonomyPanelOpen] = useState(false);
  const {
    usesTaxonomyFlow
  } = useTaxonomyFlow(focusedThreadId);
  const openZorseTaxonomyPanel = useCallback(() => {
    if (usesTaxonomyFlow) {
      setIsTaxonomyPanelOpen(true);
    }
  }, [usesTaxonomyFlow]);
  const closeZorseTaxonomyPanel = () => {
    if (usesTaxonomyFlow) {
      setIsTaxonomyPanelOpen(false);
    }
  };
  const renderZorseTaxonomyPanel = () => {
    return usesTaxonomyFlow && isTaxonomyPanelOpen ? /*#__PURE__*/_jsx(ConversationsTaxonomyPanel, {
      "data-test-id": "conversations-taxonomy-panel",
      threadId: Number(focusedThreadId),
      onClose: closeZorseTaxonomyPanel
    }) : null;
  };
  useConversationHandoffErrorAlert(focusedThreadId);
  return /*#__PURE__*/_jsxs(ThreadViewProvider, {
    threadId: focusedThreadId,
    children: [/*#__PURE__*/_jsxs(View, {
      flexGrow: 1,
      minInlineSize: MainContextMinWidth,
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(View, {
        blockSize: `${TOOLBAR_HEIGHT}px`,
        borderBlockEndWidth: "100",
        borderBlockEndColor: "border-core-subtle",
        borderBlockEndStyle: "solid",
        children: /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          children: /*#__PURE__*/_jsx(InboxViewMemberDetailsHeader, {
            threadId: focusedThreadId,
            toggleSidebar: toggleSidebar,
            openZorseTaxonomyPanel: openZorseTaxonomyPanel
          })
        })
      }), /*#__PURE__*/_jsxs(ThreadOverviewFlex, {
        children: [/*#__PURE__*/_jsx(View, {
          as: "section",
          "aria-live": "polite",
          blockSize: `calc(100% - ${TOOLBAR_HEIGHT}px)`,
          inlineSize: "100%",
          borderInlineEndWidth: "100",
          borderInlineEndColor: "border-core-subtle",
          borderInlineEndStyle: "solid",
          minInlineSize: `${MIN_MAIN_CONTEXT_WIDTH}px`,
          children: /*#__PURE__*/_jsx(InstallCodePaneWrapperContainer, {
            focusedThreadId: focusedThreadId,
            children: /*#__PURE__*/_jsx(InboxThreadView, {
              threadId: focusedThreadId,
              openZorseTaxonomyPanel: openZorseTaxonomyPanel
            })
          })
        }), /*#__PURE__*/_jsx(CSSTransition, {
          in: isOpen,
          timeout: 100,
          classNames: "right-sidebar",
          mountOnEnter: true,
          unmountOnExit: true,
          children: /*#__PURE__*/_jsx(View, {
            flexGrow: 0,
            flexShrink: 0,
            inlineSize: `${CRM_FULL_WIDTH}px`,
            children: /*#__PURE__*/_jsx(View, {
              position: "absolute",
              blockSize: `calc(100% - ${TOOLBAR_HEIGHT}px)`,
              inlineSize: `${CRM_FULL_WIDTH}px`,
              children: /*#__PURE__*/_jsx(InboxContextualSidebar, {
                focusedThreadId: focusedThreadId
              })
            })
          })
        })]
      })]
    }), renderZorseTaxonomyPanel()]
  });
};
InboxThreadOverview.displayName = 'InboxThreadOverview';
export default InboxThreadOverview;